import * as _ from 'lodash'

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_STATE':
            return {
                ...state,
                state: action.payload
            }
        case 'SET_PRODUCTS_TABLE':
            return {
                ...state,
                productsTable: action.payload
            }
        case 'SHOW_POPUP':
            if (_.isString(action.payload.message) === false) {
                action.payload.message = action.payload.message[Object.keys(action.payload.message)[0]][0]
            }
            return {
                ...state,
                popup: action.payload
            }
        case 'SHOW_SPINNER':
            return {
                ...state,
                spinner: action.payload
            }
        case 'SHOW_SEARCH':
            return {
                ...state,
                search: action.payload
            }

        case 'SET_CATEGORIES_ALL':
            return {
                ...state,
                categoriesAll: action.payload
            }

        case 'SET_OTHER_CATEGORIES_ALL':
            return {
                ...state,
                otherCategoriesAll: action.payload
            }

        case 'SET_USER_ACTIVE':
            return {
                ...state,
                userActive: action.payload
            }

        case 'SET_QUANTITY_SELECTED':
            return {
                ...state,
                quantitySelected: action.payload
            }

        case 'SET_TOTAL_SELECTED':
            return {
                ...state,
                totalSelected: action.payload
            }

        case 'SET_FORMAT_SELECTED':
            return {
                ...state,
                formatSelected: action.payload
            }

        case 'SET_PRODUCTS_TO_SHOW':
            const productsFilter = _.filter(action.payload, product => {
                if(product.Nombre.toLowerCase().indexOf('surtido') !== -1){
                  return true
                }else{
                  return (
                      ((product.UnidadesPack !== '' && product.UnidadesPack !== '-') ||
                      (product.UnidadesPallet !== '' && product.UnidadesPallet !== '-') ||
                      (product.UVenta2021Suelto !== '' && product.UVenta2021Suelto !== '-') &&
                      product.Nombre.toLowerCase().indexOf('expositor') === -1));
                }
            })
            const products = _.uniqWith(productsFilter, (x, y) => x.Nombre === y.Nombre && x.Coleccion === y.Coleccion && x.Categoria === y.Categoria && x.Color === y.Color)
            const productOrder = products.sort((a, b) => {
                return a.ID - b.ID;
            })
            return {
                ...state,
                productsToShow: productOrder
            }

        case 'SET_PRODUCTS_CHILD':
            return {
                ...state,
                productsChild: action.payload
            }

        case 'SET_PRODUCTS_CATEGORY':
            return {
                ...state,
                productsCategory: action.payload
            }

        case 'SET_ALL_PRODUCTS':
            return {
                ...state,
                allProducts: action.payload
            }

        case 'SET_ALL_COLORS':
            return {
                ...state,
                allColors: action.payload
            }

        case 'SET_ZONES':
            return {
                ...state,
                zones: {
                    ...state.zones,
                    region: action.payload.regions,
                    country: action.payload.countries
                }
            }

        case 'SET_SELECTED_PRODUCTS_LIST_ROUTE_ORIGIN':
            return {
                ...state,
                productosListRouteOrigin: action.payload
            }

        case 'SET_SELECTED_COLLECTION':
            return {
                ...state,
                selectedCollection: action.payload
            }
        case 'SET_SELECTED_FORMA':
            return {
                ...state,
                selectedForma: action.payload
            }
        case 'SET_SELECTED_HOLE':
            return {
                ...state,
                selectedHole: action.payload
            }
        case 'SET_SELECTED_NEW':
            return {
                ...state,
                selectedNew: action.payload
            }
        case 'SET_SELECTED_CHARACTERISTIC':
            return {
                ...state,
                selectedCharacteristic: action.payload
            }
        case 'PUSH_BUDGET':
            const newBudget = [...state.budget]
            const include = _.filter(newBudget, product => {
                return product.product.RefSuelto === action.payload.product.RefSuelto && product.format === action.payload.format
            })
            if (include.length > 0) {
                include[0].quantity = include[0].quantity + action.payload.quantity
                include[0].totalSelected = include[0].totalSelected + action.payload.totalSelected
            } else {
                newBudget.push(action.payload)
            }
            return {
                ...state,
                budget: newBudget
            }
        case 'PUSH_BUDGET_IMPLANTATION':
            const newBudgetImpl = [...state.budget]
            const includeImpl = _.filter(newBudgetImpl, product => {
                return product.product.RefSuelto === action.payload.product.RefSuelto && product.format === action.payload.format
            })
            if (includeImpl.length > 0) {
                includeImpl[0].quantity = includeImpl[0].quantity + action.payload.quantity
                includeImpl[0].totalSelected = includeImpl[0].totalSelected + action.payload.totalSelected
            } else {
                newBudgetImpl.push(action.payload)
            }

            return {
                ...state,
                budget: newBudgetImpl
            }
        case 'UPDATE_PRODUCT_BUDGET':
            return {
                ...state,
                budget: state.budget
            }
        case 'POP_PRODUCT_BUDGET':
            const productsBudget = _.cloneDeep(state.budget)
            _.remove(productsBudget, (el) => {
                return el.product.RefSuelto == action.payload.product.RefSuelto && el.format == action.payload.format
            })
            return {
                ...state,
                budget: productsBudget
            }
        case 'RESET_BUDGET':
            return {
                ...state,
                budget: []
            }
        case 'SET_FORMAS':
            return {
                ...state,
                formas: action.payload
            }
        case 'SET_CHARACTERISTIC':
            return {
                ...state,
                characteristics: action.payload
            }
        case 'SET_HOLES_TYPES':
            return {
                ...state,
                holesTypes: action.payload
            }
        case 'SET_SELECTED_COLOR':
            return {
                ...state,
                selectedColor: action.payload
            }
        case 'SET_COLORS':
            return {
                ...state,
                colors: action.payload
            }
        case 'SET_COLLECTIONS':
            return {
                ...state,
                collections: action.payload
            }
        case 'SET_SELECTED_MIN_MAX_DIAMETER':
            return {
                ...state,
                minMaxDiameter: action.payload
            }
        case 'SET_SELECTED_CATEGORY':
            return {
                ...state,
                selectedCategory: action.payload.categoryId,
                selectedCategoryName: action.payload.subtitle,
                headerData: {
                    ...state.headerData,
                    subtitle: action.payload.subtitle,
                    img: action.payload.img
                },
                selectedCollection: ''
            }
        case 'SET_SELECTED_CATEGORY_NAME':
            return {
                ...state,
                selectedCategoryName: action.payload,
            }
        case 'PUSH_FILTERS':
            let index = -1;
            for (let i = 0; i < state.filters.length; i++) {
                const filter = state.filters[i];
                if (filter.filterType === action.payload.filterType) {
                    index = i
                }
            }
            const aux = [...state.filters]
            if (index === -1) {
                aux.push(action.payload)
            } else {
                aux[index] = action.payload
            }

            if (action.payload.filterType === 'category' && action.payload.categoryName === 'Nuevo') {
                const indexNew = _.findIndex(aux, ['filterType', 'new'])
                if (indexNew > -1) {
                    aux.splice(indexNew, 1)
                    state.selectedNew = null
                }
            }

            return {
                ...state,
                filters: [...aux]
            }
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: [],
                selectedForma: '',
                selectedHole: '',
                selectedCharacteristic: [],
                selectedColor: {},
                minMaxDiameter: null
            }
        case 'POP_FILTER':
            const updatedFilters = state.filters.filter(el => {
                return action.payload.filterType !== el.filterType
            })
            return {
                ...state,
                filters: updatedFilters
            }
        case 'SET_PAGINATION_STATE':
            return {
                ...state,
                paginationState: action.payload
            }


        default:
            return state;

    }
}

export default reducer;